import React, { useEffect, useState } from 'react';

import { addProjectLog } from '@libs/NwLogs';

import { ProjectProvider, useProjectContextDispatch } from '@contexts/ProjectContext';

import { useProject } from '@hooks/API/Project/UseProject';

import EventDrawerHeader from '@components/EventDrawer/EventDrawerUi/EventDrawerHeader';
import { Loading } from '@components/Gui/Loading';

import EventDrawerTabsWithContext from './EventDrawerTabsWithContext';

// Component to sync projectData changes from useProject to ProjectContext
const ProjectDataSyncer = ({ projectData }) => {
    const projectDispatch = useProjectContextDispatch();

    useEffect(() => {
        if (projectData) {
            projectDispatch({ type: 'UpdateProjectData', projectData });
        }
    }, [projectData, projectDispatch]);

    return null;
};

const EventDrawerDetailsContainer = ({ filterModel, firstTab, isFetching, eventData, typeName, onSelectProject }) => {
    const [projectErrorMessage, setProjectErrorMessage] = useState('');

    // Get project ID from eventData
    const projectId = eventData?.Project?.ID;

    // Fetch project data with useProject
    const { isLoading: isLoadingProject, data: projectData } = useProject(projectId, { enabled: !!projectId });

    useEffect(() => {
        if (projectData) {
            addProjectLog(projectData);
        }
    }, [projectData]);

    if (isFetching && !eventData) {
        return <Loading textBlack />;
    }

    // If we have a projectId but project is still loading, show loading
    if (projectId && isLoadingProject) {
        return (
            <>
                <EventDrawerHeader
                    typeName={typeName}
                    data={eventData}
                    modelID={filterModel}
                    onSelectProject={onSelectProject}
                    projectErrorMessageProps={{
                        message: projectErrorMessage,
                        onClose: () => setProjectErrorMessage(''),
                    }}
                />
                <Loading textBlack />
            </>
        );
    }

    // Tabs with project data wrapped in ProjectProvider
    const projectTabs = projectData ? (
        <ProjectProvider initialProjectData={projectData} initialLayout="calendar">
            <ProjectDataSyncer projectData={projectData} />
            <EventDrawerTabsWithContext firstTab={firstTab} eventData={eventData} filterModel={filterModel} />
        </ProjectProvider>
    ) : (
        firstTab
    );

    return (
        <>
            <EventDrawerHeader
                typeName={typeName}
                data={eventData}
                modelID={filterModel}
                onSelectProject={onSelectProject}
                projectErrorMessageProps={{
                    message: projectErrorMessage,
                    onClose: () => setProjectErrorMessage(''),
                }}
            />
            {projectTabs}
        </>
    );
};

export default EventDrawerDetailsContainer;
